import React from "react";
import { Link, useLocation } from "react-router-dom";
import { siteContent } from "../../../constants/site";

export const NavLinks: React.FC<{ isActive: (path: string) => boolean }> = ({
  isActive,
}) => {
  const location = useLocation();

  // Keep active-link logic identical to the original implementation.
  const isPathActive = (path: string) => location.pathname === path;
  const activeFn = isActive ?? isPathActive;

  return (
    <ul className="hidden lg:flex items-center space-x-6 lg:space-x-10 absolute left-1/2 transform -translate-x-1/2">
      {siteContent.navbar.links.map((link, index) => (
        <li key={index}>
          <Link
            to={link.path}
            className={`text-sm lg:text-base font-bold transition-all duration-200 px-3 py-2 rounded-md ${
              activeFn(link.path)
                ? "text-primary-text bg-background-light/40"
                : "text-primary-navText hover:text-primary-text hover:bg-background-light/30"
            }`}
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

